import { __rest } from "tslib";
import * as React from 'react';
import { css } from '@patternfly/react-styles';
import styles from '@patternfly/react-styles/css/components/DataList/data-list';
import { DataListContext } from './DataList';
import { KeyTypes } from '../Select';
export var DataListItem = function DataListItem(_a) {
  var _a$isExpanded = _a.isExpanded,
      isExpanded = _a$isExpanded === void 0 ? false : _a$isExpanded,
      _a$className = _a.className,
      className = _a$className === void 0 ? '' : _a$className,
      _a$id = _a.id,
      id = _a$id === void 0 ? '' : _a$id,
      ariaLabelledBy = _a['aria-labelledby'],
      children = _a.children,
      props = __rest(_a, ["isExpanded", "className", "id", 'aria-labelledby', "children"]);

  return React.createElement(DataListContext.Consumer, null, function (_ref) {
    var isSelectable = _ref.isSelectable,
        selectedDataListItemId = _ref.selectedDataListItemId,
        updateSelectedDataListItem = _ref.updateSelectedDataListItem;

    var selectDataListItem = function selectDataListItem(event) {
      var target = event.target;

      while (event.currentTarget !== target) {
        if ('onclick' in target && target.onclick || target.parentNode.classList.contains(styles.dataListItemAction) || target.parentNode.classList.contains(styles.dataListItemControl)) {
          // check other event handlers are not present.
          return;
        } else {
          target = target.parentNode;
        }
      }

      updateSelectedDataListItem(id);
    };

    var onKeyDown = function onKeyDown(event) {
      if (event.key === KeyTypes.Enter) {
        updateSelectedDataListItem(id);
      }
    };

    return React.createElement("li", Object.assign({
      id: id,
      className: css(styles.dataListItem, isExpanded && styles.modifiers.expanded, isSelectable && styles.modifiers.selectable, selectedDataListItemId && selectedDataListItemId === id && styles.modifiers.selected, className),
      "aria-labelledby": ariaLabelledBy
    }, isSelectable && {
      tabIndex: 0,
      onClick: selectDataListItem,
      onKeyDown: onKeyDown
    }, isSelectable && selectedDataListItemId === id && {
      'aria-selected': true
    }, props), React.Children.map(children, function (child) {
      return React.isValidElement(child) && React.cloneElement(child, {
        rowid: ariaLabelledBy
      });
    }));
  });
};